import React, { FC, PropsWithChildren } from 'react'
import Modal from 'components/SA/Modal/v2'
import useIsMobile from 'hooks/useIsMobile'
import styles from '../Filters.module.scss'

type FiltersParentContainerProps = {
  name: string
}

const FiltersParentContainer: FC<PropsWithChildren<FiltersParentContainerProps>> = ({
  name,
  children,
}) => {
  const isMobileScreen = useIsMobile()

  if (!isMobileScreen) {
    return children
  }

  return (
    <Modal
      name={name}
      layout='standard'
      styleOverride={styles.mobileFiltersModal}
      isCloseButtonVisible
    >
      <div className={styles.mobileFiltersModalContent}>{children}</div>
    </Modal>
  )
}

export default FiltersParentContainer
